// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import analytics from './utils/Analytics';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/mobile.css'
import './assets/fonts/iconfont.css'
import "pdfh5/css/pdfh5.css"
Vue.use(ElementUI)
// 百度统计引入
analytics.init();

Vue.config.productionTip = false

// 引用vant
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';

// highlightjs
import hljs from 'highlight.js';

VMdPreview.use(githubTheme, {
  Hljs: hljs,
});
Vue.use(VMdPreview);

// 移动端调试工具
// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js